import React, { useState, useEffect, Fragment } from "react";
import {
	IoIosEye,
	IoMdCalendar,
	IoMdDoneAll,
	IoIosCheckmarkCircle,
	HiOutlineExclamationCircle,
} from "react-icons/all";
import { _HttpServices } from "../../../_services/_HttpServices";
import {
	Row,
	Col,
	Form,
	Button,
	OverlayTrigger,
	Tooltip,
	Image,
	Modal,
	Table,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";
// Local imports
import ReactTable from "../../../components/FilterTable";
import Loader from "../../../components/Loader";
import { storeStartEndDates } from "../../../actions/reports/outBoundReportsActions";
import { Footer } from "../../../components/Footer";
const reports = [
	{
		CreatedDate: new Date(),
		VendorName: "Akorn",
		FileName: "Sales Fee",
		FileType: "",
		FileFrequency: "monthly",
		Status: "",
	},
	{
		CreatedDate: new Date(),
		VendorName: "Genetic",
		FileName: "852",
		FileType: "",
		FileFrequency: "monthly",
		Status: "",
	},
];
const OutBoundReports = ({ dispatch, startDateFilter, endDateFilter }) => {
	const userData = localStorage.getItem("userData");
	const roleId = JSON.parse(userData)?.RoleID;
	const [reportData, setReportData] = useState([]);
	const [startDate, setStartDate] = useState(new Date().setHours(0, 0, 0, 0));
	const [endDate, setEndDate] = useState(new Date().setHours(0, 0, 0, 0));
	const [loading, setLoading] = useState(false);
	//   const [csvHeaders, setCsvHeaders] = useState([]);
	//   const [csvData, setCsvData] = useState([])

	let filterStartDate = moment(startDate).format("L");
	let filterEndDate = moment(endDate).format("L");
	const [validated, setValidated] = useState(false);
	const [btnDisable, setBtnDisable] = useState(true);
	const [greaterErr, setGreaterErr] = useState(false);
	const [emptyErr, setEmptyErr] = useState(false);
	const [checkBoxValue, setCheckBoxValue] = useState({ selectCheckBox: false });
	const [allSelcted, setAllSelceted] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [selectedPendingReports, setSelectedPendingReports] = useState({
		pendingData: [],
	});

	const [rejectionsData, setRejectedFileData] = useState([]);
	const [hasRejectionListError, setRejectionListError] = useState(false);
	const [viewRejectionModal, setViewRejectionModal] = useState(false);

	const submitHandler = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;
		if (form.checkValidity() === false) {
			e.preventDefault();
			e.stopPropagation();
		} else {
			e.preventDefault();
			if (startDate > endDate) {
				setGreaterErr(true);
				return false;
			} else if (startDate < endDate) {
				setGreaterErr(false);
			} else {
				setGreaterErr(false);
			}

			if (startDate === 0) {
				setEmptyErr(true);
				return false;
			}

			filterStartDate = moment(startDate).format("L");
			filterEndDate = moment(endDate).format("L");
			await dispatch(storeStartEndDates(startDate, new Date(endDate)));

			getReports();
			setBtnDisable(true);
		}
		setValidated(true);
	};

	const history = useHistory();
	const allCheck = () => {
		return (
			<input
				type="checkbox"
				value={allSelcted}
				checked={allSelcted}
				onChange={(e) => makeAllCheck(e)}
			></input>
		);
	};

	const rejectionListColumns = [
		{
			Header: "Line Item Number",
			accessor: "LineitemNumber",
			filter: "LineitemNumber",
			sortType: "basic",
		},
		{
			Header: "Invoice Number",
			accessor: "InvoiceNumberID",
			filter: "InvoiceNumberID",
			sortType: "basic",
		},
		{
			Header: "Contract Id",
			accessor: "ContractReferenceID",
			filter: "ContractReferenceID",
			sortType: "basic",
		},
		{
			Header: "NDC",
			accessor: "NDC",
			filter: "NDC",
			sortType: "basic",
		},
		{
			Header: "Invoice Date",
			accessor: "InvoicedDate",
			filter: "InvoicedDate",
			sortType: "basic",
		},
		{
			Header: "Rejection Descriptions",
			accessor: "RejectionDescription",
			filter: "RejectionDescription",
			sortType: "basic",
			width: 340,
		},
	];

	const columns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 110,
			Cell: ({ row: { original } }) => (
				<Fragment>
					{/* View/Navigate to view Report Data */}
					<Button
						onClick={() => navigateToReport(original)}
						variant="link"
						title="View Report"
						className="grid-action-btn"
					>
						<IoIosEye className="icon" />
					</Button>
					{/* Report Approval Button */}
					{original.CommunicationConfigurationID !== null &&
						original.ApprovedStatus === "Pending" &&
						original.Version_File === 0 &&
						roleId === 1 && (
							<Button
								style={{ color: "#3b61ad" }}
								variant="link"
								className="grid-action-btn ml-2"
								title="Approve"
								onClick={() => approveReports(original)}
							>
								<IoIosCheckmarkCircle className="icon" />
							</Button>
						)}
					{/* Invalid Configuration Notif */}
					{original.CommunicationConfigurationID === null &&
						original.ApprovedStatus === "Pending" &&
						roleId === 1 && (
							<OverlayTrigger
								placement="right"
								overlay={
									<Tooltip id="tooltip-disabled">
										Configuration not mapped.
									</Tooltip>
								}
							>
								<span className="d-inline-block">
									<Button
										variant="link"
										className="grid-action-btn ml-2"
										title="Configuration not mapped."
										disabled
										style={{ pointerEvents: "none" }}
									>
										<IoIosCheckmarkCircle className="icon" />
									</Button>
								</span>
							</OverlayTrigger>
						)}
					{/*View/Navigate to Report Rejection Reasons */}
					{original.Isrejected && (
						<Button
							variant="link"
							title="View Rejection(s)"
							className="grid-action-btn ml-2"
							onClick={
								loading
									? null
									: () => showRejectionReasons(original.FileProcessID)
							}
						>
							<HiOutlineExclamationCircle color="#ff0000" size={18} />
						</Button>
					)}
				</Fragment>
			),
		},
		{
			Header: "Approval Status",
			accessor: "ApprovedStatus",
			filter: "FileType",
			sortType: "basic",
			Cell: ({ row: { original } }) => (
				<Fragment>
					<span>{original.ApprovedStatus}</span>
				</Fragment>
			),
		},
		{
			Header: "Vendor Name",
			accessor: "VendorName",
			filter: "VendorName",
			sortType: "basic",
		},
		{
			Header: "Task Name",
			accessor: "Service_Task_Name",
			filter: "Service_Task_Name",
			sortType: "basic",
			width: 190,
		},
		{
			Header: "File Name",
			accessor: "File_Process_Name",
			filter: "File_Process_Name",
			sortType: "basic",
			width: 270,
			Cell: ({ row: { original } }) => (
				<Fragment>
					<span className="word-wrap">{original.File_Process_Name}</span>
				</Fragment>
			),
		},
		{
			Header: "File Sent Status",
			accessor: "FileSentStatus",
			filter: "FileSentStatus",
			sortType: "basic",
			width: 125,
			Cell: ({ row: { original } }) => (
				<Fragment>
					<span className={original.Isrejected ? "rejectedGridText" : ""}>
						{original.FileSentStatus}
					</span>
				</Fragment>
			),
		},
		{
			Header: "Created Date",
			accessor: "CreatedDate",
			filter: "CreatedDate",
			sortType: "basic",
			width: 160,
		},
		{
			Header: "Report Type",
			accessor: "ReportType",
			filter: "ReportType",
			sortType: "basic",
			width: 160,
		},
		{
			Header: "Version",
			accessor: "Fileversion",
			filter: "Fileversion",
			sortType: "basic",
			width: 160,
		},
	];

	const approveReports = (original) => {
		setLoading(true);
		_HttpServices
			.postData(
				`Api/Inbound/UpdateAutoApproveStatus?fileprocessId=${original.FileProcessID}`
			)
			.then((data) => {
				if (data.data !== undefined && data.data === "success") {
					selectedPendingReports.pendingData = [];
					getReports();
					setLoading(false);
				}
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	const navigateToReport = (data) => {
		localStorage.setItem("outboundreport", JSON.stringify(data));

		if (data.FileFormat === "PDF") {
			if (
				data.FileFormat === "PDF" &&
				data.TaskTypeCode === "AptevoInvoiceforChargebacks" &&
				data.FileTypeCode === "InvoiceforChargebacksandAdminFeesMonthly"
			) {
				history.push("/aptevoChargebackInvoiceReports/" + data.FileProcessID);
			} else if (
				data.FileFormat === "PDF" &&
				data.TaskTypeCode === "AptevoInvoiceforServiceFees" &&
				data.FileTypeCode === "InvoiceforServiceFeesQuarterly"
			) {
				history.push("/aptevoServiceFeesInvoiceReports/" + data.FileProcessID);
			} else if (
				data.FileFormat === "PDF" &&
				data.TaskTypeCode === "OctapharmaInvoiceforChargebacksandAdminFees" &&
				data.FileTypeCode === "InvoiceforChargebacksandAdminFeesMonthly"
			) {
				history.push("/octapharmaInvoiceReports/" + data.FileProcessID);
			} else if (
				data.FileFormat === "PDF" &&
				data.TaskTypeCode === "AkornInvoiceforServiceFees" &&
				data.FileTypeCode === "InvoiceforServiceFeesMonthly"
			) {
				history.push("/akronServiceFeesInvoiceReports/" + data.FileProcessID);
			}
		} else if (data.FileFormat === "EDI") {
			// EDI REPORTS
			// 844||CHARGEBACKS : ALL_VENDORS EXCEPT FOR ALLIANCE
			if (
				data.TaskTypeCode === "AkornChargebacks" &&
				data.FileTypeCode === "ChargebacksMonthly"
			) {
				history.push("/akornChargebacksEDI");
			} else if (
				data.TaskTypeCode === "AptevoChargebacks" &&
				data.FileTypeCode === "ChargebacksMonthly"
			) {
				history.push("/aptevoChargebacksEDI");
			} else if (
				data.TaskTypeCode === "GenentechChargebacks" &&
				data.FileTypeCode === "ChargebacksWeekly"
			) {
				history.push("/genentechChargebacksEDI");
			} else if (
				data.TaskTypeCode === "OctapharmaChargebacks" &&
				data.FileTypeCode === "ChargebacksMonthly"
			) {
				history.push("/octapharmaChargebacksEDI");
			}

			// 852||INVENTORY : ALL_VENDORS
			else if (
				(data.TaskTypeCode === "GenentechInventory" ||
					data.TaskTypeCode === "OctapharmaInventory" ||
					data.TaskTypeCode === "AllianceInventory" ||
					data.TaskTypeCode === "AkornInventory" ||
					data.TaskTypeCode === "AptevoInventory") &&
				(data.FileTypeCode === "InventoryMonthly" ||
					data.FileTypeCode === "InventoryDaily")
			) {
				history.push({
					pathname: "/InventoryEDI",
					state: { detail: data.TaskTypeCode },
				});
			}

			// 856||ADVANCE_SHIP_NOTICE : ALL_VENDORS EXCEPT ALLIANCE
			else if (
				data.TaskTypeCode === "AkornAdvanceShipNotice" &&
				data.FileTypeCode === "856"
			) {
				history.push("/akornAdvanceShipNoticeEDI");
			} else if (
				data.TaskTypeCode === "AllianceAdvanceShipNotice" &&
				data.FileTypeCode === "856"
			) {
				history.push("/allianceAdvanceShipNoticeEDI");
			} else if (
				data.TaskTypeCode === "AptevoAdvanceShipNotice" &&
				data.FileTypeCode === "856"
			) {
				history.push("/aptevoAdvanceShipNoticeEDI");
			} else if (
				data.TaskTypeCode === "GenentechAdvanceShipNotice" &&
				data.FileTypeCode === "856"
			) {
				history.push("/genentechAdvanceShipNoticeEDI");
			} else if (
				data.TaskTypeCode === "OctapharmaAdvanceShipNotice" &&
				data.FileTypeCode === "856"
			) {
				history.push("/octapharmaAdvanceShipNoticeEDI");
			}

			// 857||SALES : ALL_VENDORS
			else if (
				data.TaskTypeCode === "AkornServiceFees" &&
				data.FileTypeCode === "ServiceFeesMonthly"
			) {
				history.push("/akornServiceFeesEDI");
			} else if (
				data.TaskTypeCode === "AllianceSales" &&
				data.FileTypeCode === "SalesMonthly"
			) {
				history.push("/allianceSalesEDI");
			} else if (
				data.TaskTypeCode === "AptevoSales" &&
				data.FileTypeCode === "SalesMonthly"
			) {
				history.push("/aptevoSalesEDI");
			} else if (
				data.TaskTypeCode === "GenentechSales" &&
				data.FileTypeCode === "SalesMonthly"
			) {
				history.push("/genentechSalesEDI");
			} else if (
				data.TaskTypeCode === "OctapharmaSales" &&
				data.FileTypeCode === "SalesMonthly"
			) {
				history.push("/octapharmaSalesEDI");
			}

			// 867||PRODUCT_TRANSFER : ALL_VENDORS
			else if (
				data.TaskTypeCode === "AkornProductTransfer" &&
				data.FileTypeCode === "ProductTransferandResaleReport"
			) {
				history.push("/akornProductTransferEDI");
			} else if (
				data.TaskTypeCode === "AllianceProductTransfer" &&
				data.FileTypeCode === "ProductTransferandResaleReport"
			) {
				history.push("/allianceProductTransferEDI");
			} else if (
				data.TaskTypeCode === "AptevoProductTransfer" &&
				data.FileTypeCode === "ProductTransferandResaleReport"
			) {
				history.push("/aptevoProductTransferEDI");
			} else if (
				data.TaskTypeCode === "GenentechProductTransfer" &&
				data.FileTypeCode === "ProductTransferandResaleReport"
			) {
				history.push("/genentechProductTransferEDI");
			} else if (
				data.TaskTypeCode === "OctaPharmaProductTransfer" &&
				data.FileTypeCode === "ProductTransferandResaleReport"
			) {
				history.push("/octaPharmaProductTransferEDI");
			}
		} else {
			// GENENTECH
			if (
				data.TaskTypeCode === "GenentechChargebacks" &&
				data.FileTypeCode === "ChargebacksWeekly"
			) {
				history.push("/chargeback");
			} else if (
				data.TaskTypeCode === "GenentechSales" &&
				data.FileTypeCode === "SalesMonthly"
			) {
				history.push("/catalog");
			} else if (
				data.TaskTypeCode === "GenentechInventory" &&
				data.FileTypeCode === "InventoryDaily"
			) {
				history.push("/outbound-inventory");
			}
			// APTEVO
			else if (
				data.TaskTypeCode === "AptevoSales" &&
				(data.FileTypeCode === "SalesMonthly" ||
					data.FileTypeCode === "SalesWeekly")
			) {
				history.push("/aptevoSalesSource");
			} else if (
				data.TaskTypeCode === "AptevoInventory" &&
				data.FileTypeCode === "InventoryMonthly"
			) {
				history.push("/aptevoInventorySource");
			} else if (
				data.TaskTypeCode === "AptevoServiceFees" &&
				data.FileTypeCode === "ServiceFeesQuarterly"
			) {
				history.push("/aptevoQuarterlyServiceFees");
			} else if (
				data.TaskTypeCode === "AptevoChargebacks" &&
				data.FileTypeCode === "ChargebacksMonthly"
			) {
				history.push("/aptevoChargebacksSourceMap");
			}
			// ALLIANCE
			else if (
				data.TaskTypeCode === "AllianceSales" &&
				data.FileTypeCode === "SalesMonthly"
			) {
				history.push("/allianceSalesReportSourceData");
			}
			// OCTAPHARMA
			else if (
				data.TaskTypeCode === "OctapharmaInventory" &&
				data.FileTypeCode === "InventoryMonthly"
			) {
				history.push("/octapharmaEndOfMonthInventorySource");
			} else if (
				data.TaskTypeCode === "OctapharmaSales" &&
				data.FileTypeCode === "SalesMonthly"
			) {
				history.push("/salesReportSourceDataMonthly");
			} else if (
				data.TaskTypeCode === "OctapharmaChargebacks" &&
				data.FileTypeCode === "ChargebacksMonthly"
			) {
				history.push("/octapharmaChargebacksSourceDatamonthly");
			} else if (
				data.TaskTypeCode === "OctapharmaAdminFees" &&
				data.FileTypeCode === "AdminFeesMonthly"
			) {
				history.push("/octapharmaAdminFeesSource");
			}
			// AKORN
			else if (
				data.TaskTypeCode === "AkornServiceFees" &&
				data.FileTypeCode === "ServiceFeesMonthly"
			) {
				history.push("/sales-fee");
			}
		}
	};

	useEffect(() => {
		let today = new Date();
		let startDateTemp = new Date(startDateFilter ? startDateFilter : today);
		let startDateFil = startDateTemp.setHours(0, 0, 0, 0);

		let endDateTemp = new Date(endDateFilter ? endDateFilter : today);
		let endDateFil = endDateTemp.setHours(0, 0, 0, 0);

		setStartDate(startDateFil);
		setEndDate(endDateFil);
		filterStartDate = moment(startDateFil).format("L");
		filterEndDate = moment(endDateFil).format("L");
		getReports();
	}, []);

	async function getReports() {
		setLoading(true);
		// await _HttpServices.getData(`api/inbound/ProcessedFiles`)
		await _HttpServices
			.getData(
				`api/inbound/ProcessedFiles?startDate=${filterStartDate}&endDate=${filterEndDate}`
			)
			.then((data) => {
				const resData = data.data;
				if (resData.length > 0) {
					resData.map((x) => {
						x.CreatedDate = moment(x.CreatedDate).format("MM/DD/YYYY h:mm A");
						// x.Status = "Sent";
						x.indicator = x.ReportType === "General" ? false : true;
						x.isChecked = false;
						x.ApprovedStatus = x.AutoApprovedStatus;
						x.FileSentStatus =
							x.FileSentStatus === true
								? x.Isrejected
									? "Rejected"
									: "Sent"
								: "Not Sent";
						// x.reportType = "General";
						x.Fileversion =
							x.Fileversion == null ? "1.0" : (x.Fileversion * 1).toFixed(1);
						x.ReportType =
							x.ReportType == null
								? "General"
								: x.ReportType === "Resubmission"
								? "Reversal"
								: x.ReportType;

						return resData;
					});
				}
				setReportData(resData);
				setLoading(false);
				setValidated(false);
				// alert("setValidated(false)")
			})
			.catch((e) => {
				setLoading(false);
				setValidated(false);
				setHasError(true);
			});
	}

	const makeAllCheck = (event) => {
		if (event.target.checked === true) {
			setAllSelceted(true);
			reportData.map((item) => {
				item.isChecked = true;
			});
			// setSelectedPendingReports({...selectedPendingReports, pendingData: reportData});
			selectedPendingReports.pendingData = reportData;
		} else {
			setAllSelceted(false);
			reportData.map((item) => {
				item.isChecked = false;
			});
			selectedPendingReports.pendingData = [];
			// setSelectedPendingReports({...selectedPendingReports, pendingData: []})
		}
	};

	// To get rejection reasons for selected file and show in popup modal
	const showRejectionReasons = async (fileProcessId) => {
		setLoading(true);
		await _HttpServices
			.getData(
				`api/inbound/Get849RejectionCodesData?fileprocessId=${fileProcessId}`
			)
			.then((response) => {
				let responseData = response.data;
				setLoading(false);
				setRejectedFileData(responseData);
				setViewRejectionModal(true);
				setRejectionListError(false);
			})
			.catch((e) => {
				setLoading(false);
				setRejectionListError(true);
				setViewRejectionModal(true);
			});
	};

	// To close rejections modal
	const closeRejectionsModal = () => {
		setViewRejectionModal(false);
		setRejectionListError(false);
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">Outbound Reports</h2>
				{/* <span role="img" aria-label="emoji">💩</span> */}
				{/* <Button><IoIosAdd className="icon btn-icon" />Add</Button> */}
			</div>

			<Row>
				<Col md={12}>
					<div className="card pt-2 mb-4">
						<div className="card-body">
							<Form noValidate validated={validated} onSubmit={submitHandler}>
								<Row>
									<Col md={3}>
										<Form.Group>
											<div className="date-picker ungroup-date-picker pos-rl">
												<Form.Label htmlFor="StartDate">Since</Form.Label>
												<IoMdCalendar className="icon date-icon" />
												<DatePicker
													selected={startDate}
													onChange={(date) => {
														setBtnDisable(false);
														return setStartDate(date);
													}}
													onSelect={(date) => {
														setGreaterErr(false);
														setBtnDisable(false);
													}}
													maxDate={new Date()}
													required
													className={
														greaterErr
															? "form-control is-invalid"
															: "form-control"
													}
												/>
												{emptyErr ? (
													<div className="err-feedback">
														Please select Start Date.
													</div>
												) : null}
												{greaterErr ? (
													<div className="err-feedback">
														Since should not be greater than until date.
													</div>
												) : null}
											</div>
										</Form.Group>
									</Col>
									<Col md={3}>
										<Form.Group>
											<div className="date-picker ungroup-date-picker pos-rl">
												<Form.Label htmlFor="EndDate">Until</Form.Label>
												<IoMdCalendar className="icon date-icon" />
												<DatePicker
													selected={endDate}
													onChange={(date) => {
														setBtnDisable(false);
														return setEndDate(date);
													}}
													onSelect={(date) => {
														setBtnDisable(false);
													}}
													maxDate={new Date()}
													required
													className="form-control"
												/>
												<Form.Control.Feedback type="invalid">
													Please select End Date.
												</Form.Control.Feedback>
											</div>
										</Form.Group>
									</Col>
									<Col md={3}>
										<Form.Group className="mt-2">
											<Button
												type="submit"
												className="mt-3"
												disabled={btnDisable}
											>
												<IoMdDoneAll className="icon btn-icon" />
												Submit
											</Button>
										</Form.Group>
									</Col>
									{/* <Col md={3}>
                                        <Form.Group className="mt-1">
                                            <Button type="submit" className="mt-4" onClick={()=>exportExcel(invoices)}>Download Excel </Button>
                                        </Form.Group>
                                    </Col> */}
								</Row>
							</Form>
						</div>
					</div>
					{/* {selectedPendingReports.pendingData.length > 0 && (
            <div>
              <Button onClick={approveReports}>Approve</Button>
            </div>
          )} */}
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load Outbound Reports.</p>
								) : (
									<Fragment>
										{loading ? (
											<Loader />
										) : reportData.length > 0 ? (
											<ReactTable
												columns={columns}
												data={reportData}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
								{/* {testData.length >0 && testHeaders.length> 0 &&
                  <ReactTable columns={testHeaders} data={testData} />
                  } */}
							</div>
						</div>
					</div>
				</Col>
			</Row>

			{/* Modal to show rejection reasons */}
			{viewRejectionModal && (
				<Modal
					show={viewRejectionModal}
					backdrop="static"
					keyboard={false}
					size="lg"
					centered
					onHide={() => closeRejectionsModal()}
				>
					<Modal.Header closeButton>
						<Modal.Title>Rejection reasons</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						{hasRejectionListError ? (
							<p>Error occurred. Unable to load rejections list.</p>
						) : (
							<Fragment>
								{rejectionsData.length > 0 ? (
									<ReactTable
										columns={rejectionListColumns}
										data={rejectionsData}
										defaultPageSize={10}
									/>
								) : (
									<div className="no-data">No data found.</div>
								)}
							</Fragment>
						)}
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button onClick={() => closeRejectionsModal()}>
								<IoMdDoneAll className="icon btn-icon" />
								Ok
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			)}
			<Footer />
		</section>
	);
};

const mapStateToProps = (state) => ({
	startDateFilter: state.outBound.startDate,
	endDateFilter: state.outBound.endDate,
});

export default connect(mapStateToProps)(OutBoundReports);
